export const updateFileProp = (array, fileId, newData) => {
  return array.map((file) => file.uid === fileId ? {...file, ...newData} : file )
};

export default updateFileProp;
